<template>
  <zb-tooltip ref="drawer" class="relative">
    <template v-slot:trigger="{ toggle, isShowing }">
      <slot>
        <div class="flex items-center w-full relative">
          <input
            class="custom-select-input pl-12 input input-tall w-full cursor-pointer"
            readonly
            :placeholder="placeholder"
            :value="currentValue"
            @click="clickInput(toggle)"
          />
          <svg
            width="20"
            height="20"
            class="user-icon text-black-light-5"
            fill="currentColor"
          >
            <use xlink:href="/img/sprite.svg#ic_people"></use>
          </svg>
          <svg
            width="24"
            height="24"
            style="right: 10px"
            class="flex-none pointer-events-none absolute"
            :class="{ 'transform rotate-180 fill-secondary': isShowing }"
          >
            <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
          </svg>
        </div>
      </slot>
    </template>

    <template>
      <slot name="options">
        <div class="w-full bg-white p-6 rounded select-list text-left scroller">
          <div v-for="room in currentRooms" :key="room.id" class="mb-8">
            <h4 class="fs-18 font-medium mb-6">Room {{ room.id }}</h4>
            <div class="mb-6 flex items-center justify-between">
              <span>Adults</span>
              <counter
                :value="room.adults"
                @input="(val) => changeAdults(room.id, val)"
                type="adults"
              />
            </div>
            <div class="mb-6 flex items-center justify-between">
              <div class="flex flex-col">
                <span>Children</span>
                <span class="fs-12"> Ages 0 to 17 </span>
              </div>

              <counter
                :value="room.children.length"
                @input="(val) => changeChildren(room.id, val)"
                type="children"
              />
            </div>

            <div
              v-if="room.children.length"
              v-for="(item, index) in room.children"
              :key="index"
              class="flex items-center justify-between mb-6"
            >
              <div>Age of child {{ item.id }}</div>

              <div class="wrap-age-child-select">
                <div class="mb-2">
                  <age-child-select :child="item" :room-id="room.id" />
                </div>
              </div>
            </div>
            <div
              v-if="currentRooms.length > 1"
              @click="$store.commit('removeRoom', room.id)"
              class="text-secondary font-medium cursor-pointer mt-0 text-right"
            >
              Remove room
            </div>
          </div>
          <div
            v-if="currentRooms.length < 3"
            @click="addAnotherRoom()"
            class="text-secondary font-medium cursor-pointer mb-8 text-right"
          >
            Add another room
          </div>

          <div v-if="currentRooms.length === 3" class="text-right mb-8">
            <p class="mb-0">Want to personalise your stay?</p>
            <trengo-link>
              <template v-slot="{ openChat }">
                <p
                  @click="openChat()"
                  class="flex items-center justify-end font-medium text-primary cursor-pointer"
                >
                  <span class="underline"> Chat with us </span>
                </p>
              </template>
            </trengo-link>
          </div>

          <div class="flex justify-end">
            <button
              @click="handleDone()"
              class="btn done-btn btn-secondary mt-2 w-fit-content"
            >
              Done
            </button>
          </div>
        </div>
      </slot>
    </template>
  </zb-tooltip>
</template>

<script>
import BottomDrawer from "../../core/BottomDrawer";
import TrengoLink from "../../core/TrengoLink";
import Tooltip from "../../core/Tooltip.vue";
import Counter from "./Counter";
import AgeChildSelect from "./AgeChildSelect";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    TrengoLink,
    BottomDrawer,
    "zb-tooltip": Tooltip,
    Counter,
    AgeChildSelect,
  },
  props: ["placeholder"],
  computed: {
    ...mapState(["roomsFilter"]),
    ...mapGetters(["travellersDisplay"]),
    currentValue() {
      return this.travellersDisplay({ withRoom: true });
    },
    currentRooms() {
      if (this.roomsFilter.length) {
        return this.roomsFilter;
      } else {
        return [{ id: 1, adults: 2, children: [] }];
      }
    },
  },
  methods: {
    handleDone(option) {
      if (this.$refs.drawer && this.$refs.drawer.hide) {
        this.$refs.drawer.hide();
      }
    },
    addAnotherRoom() {
      if (!this.roomsFilter.length) {
        this.$store.commit("addRoom", [
          { id: 1, adults: 2, children: [] },
          { id: 2, adults: 2, children: [] },
        ]);
      } else {
        this.$store.commit("addRoom", [
          ...this.roomsFilter,
          { id: this.roomsFilter.length + 1, adults: 2, children: [] },
        ]);
      }
    },
    changeAdults(id, val) {
      this.$store.commit("setAdults", { id, adults: val });
    },
    changeChildren(id, val) {
      this.$store.commit("setChildren", { id, child: val });
    },
    show() {
      if (this.$refs.drawer && this.$refs.drawer.show) {
        this.$refs.drawer.show();
      }
    },
    showAndSelectDefault() {
      this.clickInput(() => {
        this.$refs.drawer.show();
      });
    },
    clickInput(toggle) {
      if (!this.roomsFilter.length) {
        this.$store.commit("addRoom", [{ id: 1, adults: 2, children: [] }]);
      }
      toggle();
    },
  },
};
</script>

<style scoped>
.wrap-age-child-select {
  width: 84px;
}

.wrap-age-child-select ::v-deep .select-list {
  height: 200px;
}

.pl-12 {
  padding-left: 3rem !important;
}

.user-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}

.done-btn {
  padding: 0rem 2rem;
  min-width: 42px;
}

.note-text {
  color: var(--error-primary);
  font-size: 14px;
}

.select-list {
  max-height: 600px;
  overflow-y: auto;
}

.custom-select-input {
  width: 300px;
}

@media (max-width: 600px) {
  .custom-select-input {
    width: 100%;
  }
}
</style>
